import {AccessibleStepsService} from '../services/accessible-steps/accessible-steps.service';

export const fetchAccessibleSteps = (
    accessibleStepsService: AccessibleStepsService): () => Promise<void> => {
    return async (): Promise<void> => {
        await accessibleStepsService.getAndCacheAccessibleSteps();
    };
};
